import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { TTEntryInput } from "@/types";

export type TTEditForm = {
  rowsFrom: undefined | number;
  rowsTo: undefined | number;
  unit: undefined | TTEntryInput["unit"];
  mode: undefined | TTEntryInput["mode"];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'TTEditRowsModal',
  props: {
    value: { type: Boolean, default: false }
  },
  emits: ["input", "update"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "update", form: TTEditForm): void;
}), expose: any, slots: any, attrs: any }) {





const editForm = ref({
    rowsFrom: undefined,
    rowsTo: undefined,
    unit: undefined,
    mode: undefined
} as TTEditForm);

const modeSelectOptions = [
    { label: "Not Edit", value: undefined },
    { label: "R", value: "R" }
  ];

function toggleModal(val: boolean) {
  emit("input", val);
}

function handleSubmit() {
  const form = editForm.value;
  if (!form.rowsFrom || !form.rowsTo) {
    return;
  }
  if (!form.unit && !form.mode) {
    return;
  }

  emit("update", editForm.value);
  editForm.value.rowsFrom = undefined;
  editForm.value.rowsTo = undefined;
  editForm.value.unit = undefined;
  editForm.value.mode = undefined;

  toggleModal(false);
}

return { __sfc: true,emit, editForm, modeSelectOptions, toggleModal, handleSubmit }
}

})